module.exports = __webpack_public_path__ + "img/board_layout_4.9809df50.png";